module.exports = __webpack_public_path__ + "static/media/ag.ae994824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ag.png
// module id = 1778
// module chunks = 0